export default __webpack_public_path__ + "static/media/client10.87414ecf.png";